import {
  GET_STUDENT_ATTENDANCE_LIST,
  GET_STUDENT_ATTENDANCE_LIST_NEXT,
  GET_STUDENT_ATTENDANCE_AVERAGE,
  GET_STUDENT_ATTENDANCE_SUMMARY_LIST,
  CHANGE_ATTENDANCE_MODULES_FILTERS,
  CLEAR_ATTENDANCE_MODULES_FILTERS,
  GET_STUDENT_MODULE_LIST,
  GET_STUDENT_MODULE_ATTENDANCE_AVERAGE,
  GET_STUDENT_MODULE_ATTENDANCE_SUMMARY_LIST,
  GET_STUDENT_MODULE_ATTENDANCE_LIST,
  FILTER_SUMMARY_BY_DATE_RANGE, RESET_ATTENDANCE_TIME_PICKERS
} from '../action-types'
import {
  SET_STUDENT_ATTENDANCE_LIST,
  APPEND_STUDENT_ATTENDANCE_LIST,
  SET_STUDENT_ATTENDANCE_AVERAGE,
  SET_STUDENT_ATTENDANCE_DATES,
  SET_STUDENT_ATTENDANCE_STUDENT,
  SET_STUDENT_ATTENDANCE_LIST_LOADING,
  SET_STUDENT_ATTENDANCE_SUMMARY_LIST,
  SOFT_RESET_ATTENDANCE_LIST,
  CLEAR_MODULE_FILTERS,
  TOGGLE_MODULE_LIST_FILTER,
  SET_STUDENT_AVAILABLE_MODULES,
  SET_ATTENDANCE_STUDENT_MODULES,
  SET_ATTENDANCE_MODULE,
  SET_ATTENDANCE_MODULE_FROM_TAB,
  APPLY_DATE_RANGE_FILTERS,
  SET_DATE_VALIDATION_ERROR,
  RESET_ATTENDANCE_DATES,
  RESET_ATTENDANCE_STUDENT_MODULES,
  RESET_MODULE_FILTERS
} from '../mutation-types'
import server from '../server'
import moment from 'moment-es6'
import axios from 'axios'

const state = {
  studentId: 0,
  loadingList: false,
  currentPage: -1,
  pageSize: 50,
  allLoaded: false,
  studentAttendance: [],
  studentAttendanceFilteredByDates: [],
  studentAttendanceSummary: [],
  studentAttendanceAverage: 0,
  fromDate: moment().subtract(28, 'days').format('YYYY-MM-DD'),
  toDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
  filterFields: {
    moduleFilterTypes: {
      // header: 'Module Status',
      header: '',
      values: {
        CURRENT: {
          value: true,
          text: 'current_label'
        },
        COMPLETE: {
          value: false,
          text: 'complete_label'
        }
      }
    }
  },
  modules: [],
  selectedModule: '',
  functions: {
    moduleAttendance: 'ATTMODTAB'
  },
  options: {
    enable: {
      enableModuleAttn: 'ENBATTMOD'
    }
  },
  minDate: '',
  maxDate: '',
  originalMinDate: '',
  originalMaxDate: '',
  dateValidationError: false
}

const mutations = {
  [RESET_ATTENDANCE_DATES] (state) {
    state.minDate = state.originalMinDate
    state.maxDate = state.originalMaxDate
  },
  [SET_DATE_VALIDATION_ERROR] (state, isError) {
    state.dateValidationError = isError
  },
  [APPLY_DATE_RANGE_FILTERS] (state, dateRange) {
    state.minDate = dateRange.newDateRange.startDate
    state.maxDate = dateRange.newDateRange.endDate
    const fromDate = (new Date(state.minDate)).setHours(0, 0, 0, 0)
    const toDate = (new Date(state.maxDate)).setHours(23, 59, 59, 0)
    state.studentAttendanceFilteredByDates = state.studentAttendance.filter(item => {
      if (!item.expectedAttendanceDatetime) {
        const weekRange = item.weekDateRange.split(' - ')
        const startWeek = moment(weekRange[0], 'DD/MM/YYYY').unix() * 1000
        const endWeek = moment(weekRange[1], 'DD/MM/YYYY').unix() * 1000
        const startFilter = new Date(state.minDate).getTime()
        const endFilter = new Date(state.maxDate).getTime()
        return startWeek >= startFilter && endWeek <= endFilter
      } else {
        const date = (new Date(item.expectedAttendanceDatetime)).setHours(0, 0, 0, 0)
        return date >= fromDate && date <= toDate
      }
    })
  },
  [SET_STUDENT_ATTENDANCE_LIST] (state, list) {
    state.studentAttendance = list
    state.studentAttendanceFilteredByDates = list
    const availableDates = []
    state.studentAttendance.forEach(item => {
      if (item.expectedAttendanceDatetime) {
        availableDates.push(item.expectedAttendanceDatetime)
      }
    })

    if (availableDates.length > 0) {
      availableDates.sort((a, b) => new Date(a) - new Date(b))
      const latestAvailableAttendanceDate = availableDates[0]
      state.minDate = moment(latestAvailableAttendanceDate).format('YYYY-MM-DD')
      state.maxDate = moment(new Date()).format('YYYY-MM-DD')
      state.originalMinDate = moment(latestAvailableAttendanceDate).format('YYYY-MM-DD')
      state.originalMaxDate = moment(new Date()).format('YYYY-MM-DD')
    }
  },
  [SET_STUDENT_ATTENDANCE_SUMMARY_LIST] (state, list) {
    state.studentAttendanceSummary = list
  },
  [APPEND_STUDENT_ATTENDANCE_LIST] (state, list) {
    state.studentAttendance.splice(state.studentAttendance.length, ...list)
  },
  [SET_STUDENT_ATTENDANCE_AVERAGE] (state, studentAttendanceAverage) {
    state.studentAttendanceAverage = studentAttendanceAverage
  },
  [SET_STUDENT_ATTENDANCE_DATES] (state, {fromDate, toDate}) {
    state.fromDate = fromDate
    state.toDate = toDate
  },
  [SET_STUDENT_ATTENDANCE_STUDENT] (state, studentId) {
    state.studentId = studentId
    state.studentAttendance = []
    state.currentPage = -1
    state.allLoaded = false
    state.selectedModule = ''
  },
  [SET_STUDENT_ATTENDANCE_LIST_LOADING] (state, {loading, currentPage, allLoaded}) {
    state.loadingList = loading
    if (loading) {
      state.currentPage = currentPage
      state.allLoaded = false
    } else {
      state.allLoaded = allLoaded
    }
  },
  [SOFT_RESET_ATTENDANCE_LIST] (state) {
    state.studentAttendance = []
  },
  [TOGGLE_MODULE_LIST_FILTER] (state, {filterType, filterName}) {
    state.filterFields[filterType].values[filterName].value = !state.filterFields[filterType].values[filterName].value
  },
  [CLEAR_MODULE_FILTERS] (state) {
    state.filterFields.moduleFilterTypes.values.CURRENT.value = false
    state.filterFields.moduleFilterTypes.values.COMPLETE.value = false
  },
  [RESET_MODULE_FILTERS] (state) {
    state.filterFields.moduleFilterTypes.values.CURRENT.value = true
    state.filterFields.moduleFilterTypes.values.COMPLETE.value = false
  },
  [SET_STUDENT_AVAILABLE_MODULES] (state, value) {
    state.modules = value
  },
  [SET_ATTENDANCE_STUDENT_MODULES] (state, modules) {
    let list = []
    modules.forEach((module) => {
      list.push({
        text: `${module.moduleCode} - ${module.moduleDescription} - ${module.formattedAcademicYear}`,
        value: module.studentModuleId
      })
    })
    state.modules = list
  },
  [RESET_ATTENDANCE_STUDENT_MODULES] (state) {
    state.modules = []
  },
  [SET_ATTENDANCE_MODULE_FROM_TAB] (state, module) {
    state.selectedModule = module.studentModuleId
    state.modules = [{
      text: `${module.moduleCode} - ${module.moduleName} - ${module.formattedAcademicYear}`,
      value: module.studentModuleId
    }]
  },
  [SET_ATTENDANCE_MODULE] (state, value) {
    state.selectedModule = value
  }
}

const getStudentModuleAttendanceList = function (commit, state, pageNumber, commitName, actionData) {
  const activeFilters = []
  if (state.filterFields.moduleFilterTypes.values.CURRENT.value) {
    activeFilters.push('CURRENT')
  }
  if (state.filterFields.moduleFilterTypes.values.COMPLETE.value) {
    activeFilters.push('COMPLETE')
  }
  commit(SET_STUDENT_ATTENDANCE_LIST_LOADING, {loading: true, currentPage: pageNumber})
  let data = {studentModuleId: null, studentId: state.studentId, moduleFilterTypes: activeFilters}
  if (state.selectedModule !== '') {
    data = { studentModuleId: state.selectedModule, studentId: state.studentId, moduleFilterTypes: activeFilters }
  }
  server.postReplayable(`/core/student/${state.studentId}/module_attendance/filter`, data, actionData).then(result => {
    commit(commitName, result.data)
    commit(SET_STUDENT_ATTENDANCE_LIST_LOADING, {loading: false, allLoaded: true})
  })
}

const getStudentAttendanceList = function (commit, state, pageNumber, commitName, actionData) {
  commit(SET_STUDENT_ATTENDANCE_LIST_LOADING, {loading: true, currentPage: pageNumber})
  server.postReplayable(`/core/student/${state.studentId}/attendance/filter`, {
    ascDesc: 'DESC',
    sortBy: 'EXPECTED_ATTENDANCE_DATE',
    pageNumber: pageNumber,
    pageSize: state.pageSize,
    fromDate: state.fromDate,
    toDate: state.toDate,
    studentId: state.studentId
  }, actionData).then(result => {
    commit(commitName, result.data.content)
    commit(SET_STUDENT_ATTENDANCE_LIST_LOADING, {loading: false, allLoaded: result.data.last})
  })
}

const actions = {
  [GET_STUDENT_MODULE_LIST] ({rootState, commit, state}, moduleSearch) {
    if (moduleSearch.length < 3) return
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/attendance/match/${state.studentId}/${moduleSearch}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: { action: GET_STUDENT_MODULE_LIST, data: moduleSearch }
    })
      .then((res) => {
        commit(SET_ATTENDANCE_STUDENT_MODULES, res.data)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [GET_STUDENT_MODULE_ATTENDANCE_LIST] ({commit, state}) {
    const actionData = { action: GET_STUDENT_MODULE_ATTENDANCE_LIST }
    commit(SOFT_RESET_ATTENDANCE_LIST)
    getStudentModuleAttendanceList(commit, state, 0, SET_STUDENT_ATTENDANCE_LIST, actionData)
  },
  [GET_STUDENT_ATTENDANCE_LIST] ({commit, state}) {
    const actionData = { action: GET_STUDENT_ATTENDANCE_LIST }
    commit(SOFT_RESET_ATTENDANCE_LIST)
    getStudentAttendanceList(commit, state, 0, SET_STUDENT_ATTENDANCE_LIST, actionData)
  },
  [GET_STUDENT_ATTENDANCE_LIST_NEXT] ({commit, state}) {
    const actionData = { action: GET_STUDENT_ATTENDANCE_LIST_NEXT }
    if (!state.allLoaded) {
      getStudentAttendanceList(commit, state, state.currentPage + 1, APPEND_STUDENT_ATTENDANCE_LIST, actionData)
    }
  },
  [GET_STUDENT_MODULE_ATTENDANCE_AVERAGE] ({commit, state}) {
    const actionData = { action: GET_STUDENT_MODULE_ATTENDANCE_AVERAGE }
    const url = `/core/student/${state.studentId}/attendance_percentage_detail`
    const activeFilters = []
    if (state.filterFields.moduleFilterTypes.values.CURRENT.value) {
      activeFilters.push('CURRENT')
    }
    if (state.filterFields.moduleFilterTypes.values.COMPLETE.value) {
      activeFilters.push('COMPLETE')
    }
    let data = {studentModuleId: null, studentId: state.studentId, moduleFilterTypes: activeFilters}
    if (state.selectedModule !== '') {
      data = { studentModuleId: state.selectedModule, studentId: state.studentId, moduleFilterTypes: activeFilters }
    }
    server.postReplayable(url, data, actionData).then(result => {
      commit(SET_STUDENT_ATTENDANCE_AVERAGE, result.data)
    }).catch(error => {
      console.error(error)
    })
  },
  [GET_STUDENT_MODULE_ATTENDANCE_SUMMARY_LIST] ({commit, state}) {
    commit(SET_DATE_VALIDATION_ERROR, false)
    const actionData = { action: GET_STUDENT_MODULE_ATTENDANCE_SUMMARY_LIST }
    const url = `/core/student/${state.studentId}/module_attendance/summary`
    const activeFilters = []
    if (state.filterFields.moduleFilterTypes.values.CURRENT.value) {
      activeFilters.push('CURRENT')
    }
    if (state.filterFields.moduleFilterTypes.values.COMPLETE.value) {
      activeFilters.push('COMPLETE')
    }
    let data = {studentModuleId: null, studentId: state.studentId, moduleFilterTypes: activeFilters}
    if (state.selectedModule !== '') {
      data = { studentModuleId: state.selectedModule, studentId: state.studentId, moduleFilterTypes: activeFilters }
    }
    server.postReplayable(url, data, actionData).then(result => {
      commit(SET_STUDENT_ATTENDANCE_SUMMARY_LIST, result.data)
    }).catch(error => {
      console.error(error)
    })
  },
  [GET_STUDENT_ATTENDANCE_AVERAGE] ({commit, state}) {
    const actionData = { action: GET_STUDENT_ATTENDANCE_AVERAGE }
    const url = `/core/student/${state.studentId}/attendance_percentage/${state.fromDate}/${state.toDate}`
    server.getReplayable(url, actionData).then(result => {
      commit(SET_STUDENT_ATTENDANCE_AVERAGE, result.data)
    })
  },
  [GET_STUDENT_ATTENDANCE_SUMMARY_LIST] ({commit, state}) {
    const actionData = { action: GET_STUDENT_ATTENDANCE_SUMMARY_LIST }
    const url = `/core/student/${state.studentId}/attendance/${state.fromDate}/${state.toDate}`
    server.getReplayable(url, actionData)
      .then(result => {
        commit(SET_STUDENT_ATTENDANCE_SUMMARY_LIST, result.data)
      })
      .catch(error => {
        console.error(error)
      })
  },
  [CHANGE_ATTENDANCE_MODULES_FILTERS] ({state, commit, dispatch}, filterObject) {
    commit(TOGGLE_MODULE_LIST_FILTER, filterObject)
    dispatch(GET_STUDENT_MODULE_ATTENDANCE_LIST)
    dispatch(GET_STUDENT_MODULE_ATTENDANCE_SUMMARY_LIST)
    dispatch(GET_STUDENT_MODULE_ATTENDANCE_AVERAGE)
  },
  [CLEAR_ATTENDANCE_MODULES_FILTERS] ({state, commit, dispatch}, filterObject) {
    commit(CLEAR_MODULE_FILTERS)
    dispatch(GET_STUDENT_MODULE_ATTENDANCE_LIST)
    dispatch(GET_STUDENT_MODULE_ATTENDANCE_SUMMARY_LIST)
    dispatch(GET_STUDENT_MODULE_ATTENDANCE_AVERAGE)
  },
  [FILTER_SUMMARY_BY_DATE_RANGE] ({state, commit, dispatch}, dateRange) {
    commit(SET_DATE_VALIDATION_ERROR, false)
    commit(APPLY_DATE_RANGE_FILTERS, dateRange)
  },
  [RESET_ATTENDANCE_TIME_PICKERS] ({commit, state}) {
    commit(RESET_ATTENDANCE_DATES)
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/attendanceModule.js